import { FiArrowRight, FiBookOpen, FiCalendar, FiClock } from 'react-icons/fi';
import { RESOLVE_PORTFOLIO_MEDIA_URL } from '../../../_Shared/resolveMediaUrl';

const dateLabel = (value) => {
    if (!value) return '';
    const date = new Date(`${value}T12:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat('es-AR', { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
};

export const BlogSection = ({ posts = [], onOpen }) => {
    const ordered = [...posts].sort((a, b) => Number(Boolean(b.featured)) - Number(Boolean(a.featured)));

    return (
        <section id="blog" className="PB__section PB__blog_section">
            <div className="PB__blog_glow PB__blog_glow--a" />
            <div className="PB__blog_glow PB__blog_glow--b" />
            <div className="PB__container PB__relative">
                <div className="PB__section_header">
                    <div><div className="PB__section_kicker"><FiBookOpen /> Notas tecnicas</div><h2 className="PB__section_title">blog <em>·</em></h2></div>
                    <p>Arquitectura, producto, aprendizajes y decisiones reales de desarrollo.</p>
                </div>
                <div className="PB__blog_grid">
                    {ordered.map((post) => (
                        <article className={`PB__blog_card ${post.featured ? 'is-highlighted' : ''}`} key={post.id || post.slug}>
                            <div className="PB__blog_media">
                                {post.image ? <img src={RESOLVE_PORTFOLIO_MEDIA_URL(post.image)} alt={post.title} /> : <div className="PB__blog_placeholder"><FiBookOpen /></div>}
                                <span className="PB__blog_category">{post.category || 'Desarrollo'}</span>
                                {post.featured && <span className="PB__blog_featured">Destacado</span>}
                            </div>
                            <div className="PB__blog_body">
                                <div className="PB__blog_meta">
                                    {post.published_at && <span><FiCalendar /> {dateLabel(post.published_at)}</span>}
                                    {post.read_time && <span><FiClock /> {post.read_time}</span>}
                                </div>
                                <h3>{post.title}</h3>
                                <p>{post.excerpt}</p>
                                <div className="PB__blog_tags">{(post.tags || []).slice(0, 3).map((tag) => <span key={tag}>#{tag}</span>)}</div>
                                <button type="button" onClick={() => onOpen(post)}>Leer articulo <FiArrowRight /></button>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
